import { FETCH_ALL_RETURNED_REQU } from '../../constants/actionTypes'

export default (laReturned = {}, action) => {
    switch (action.type) {
        case FETCH_ALL_RETURNED_REQU:
            return action.payload;
        default:
            return laReturned;
    }
}